import { importAll } from '@/utils/importHelpers';

// Import all logo images from the floating directory
const floatingImages = importAll(
  import.meta.glob('/src/assets/images/floating/*.{png,jpg,jpeg,gif}', { eager: true })
) as string[];

export const LOGO_IMAGES = floatingImages;